module.exports = __webpack_public_path__ + "img/back-4.c94dbb8a.png";